module.exports = __webpack_public_path__ + "img/video-post-thumb.76d8cd34.jpg";